import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const FIREBASE_API_KEY = process.env?.REACT_APP_FIREBASE_API_KEY;
const FIREBASE_AUTH_DOMAIN = process.env?.REACT_APP_FIREBASE_AUTH_DOMAIN;
const FIREBASE_DATABASE_URL = process.env?.REACT_APP_FIREBASE_DATABASE_URL;
const FIREBASE_PROJECT_ID = process.env?.REACT_APP_FIREBASE_PROJECT_ID;
const FIREBASE_STORAGE_BUCKET = process.env?.REACT_APP_FIREBASE_STORAGE_BUCKET;
const FIREBASE_MESSAGING_SENDER_ID =
  process.env?.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const FIREBASE_APP_ID = process.env?.REACT_APP_FIREBASE_APP_ID;
const FIREBASE_MEASUREMENT_ID = process.env?.REACT_APP_FIREBASE_MEASUREMENT_ID;

// if (!firebase.app.length) {
firebase.initializeApp({
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  databaseURL: FIREBASE_DATABASE_URL,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
});
// }

export const db = firebase.firestore();

// Test stands only: REACT_APP_USE_EMULATOR=true routes Auth and Firestore to the
// local emulators of the demo-gastronaut project instead of production.
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
  const host = process.env.REACT_APP_EMULATOR_HOST || '127.0.0.1';
  firebase.auth().useEmulator(`http://${host}:${process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099}`);
  db.useEmulator(host, Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080));
}

export default firebase;
